var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AppointmentDashboardCard_1;
import { Avatar, Button, Card, ProgressBar, Tag } from '@philips-internal/oswald-ui-components';
import { ButtonTheme, Placement, SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, func, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import AppointmentDashboardCardAPI from './appointment-dashboard-card-api';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ReactComponent as ConfirmedSVG } from '../../assets/images/icons/Confirmed.svg';
import { ReactComponent as CalendarGray75SVG } from '../../assets/images/global/Calendar-DLS.svg';
import { ReactComponent as LocationGray75SVG } from '../../assets/images/global/DLS_Location_16.svg';
import { ReactComponent as TeleconsultationSVG } from '../../assets/images/global/camera-available.svg';
import { ReactComponent as InExecutionSVG } from '../../assets/images/icons/In_execution.svg';
import { ReactComponent as CanceledSVG } from '../../assets/images/icons/Canceled.svg';
import { ReactComponent as RequestedSVG } from '../../assets/images/icons/Requested.svg';
import { ReactComponent as CheckSVG } from '../../assets/images/icons/check.svg';
import { ReactComponent as LostSVG } from '../../assets/images/icons/Lost.svg';
import { getPreferredTime, SCHEDULE_OTHER_STATUS, SCHEDULE_STATUS } from '../../util/card-util';
import CheckupAvatarSVG from '../../assets/images/avatars/avatar-checkup.svg';
import ConsultationAvatarSVG from '../../assets/images/global/consultation.svg';
import ExamAvatarSVG from '../../assets/images/global/exams.svg';
import PhysicianAvatarSVG from '../../assets/images/avatars/avatar-phys.svg';
import ServiceAvatarSVG from '../../assets/images/global/avatar-service.svg';
import './appointment-dashboard-card.css';
import moment from 'moment';
import { AppointmentCardUtils } from '../../util/appointment-card-utils';
import { EXPRESSIONS } from '../../constants';
import { ScheduleType } from '../pseudonym-suggestion-card-item/pseudonym-suggestion-card-item-type';
let AppointmentDashboardCard = class AppointmentDashboardCard extends Component {
    constructor() {
        super(...arguments);
        this.abortOnClickCard = false;
        this.handleClick = () => {
            if (this.abortOnClickCard) {
                this.abortOnClickCard = false;
                return;
            }
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        ...this.props
                    }
                }));
            }
        };
        this.getAvatar = (ieScheduleType) => {
            switch (ieScheduleType) {
                case ScheduleType.EXAM:
                    return ExamAvatarSVG;
                case ScheduleType.SERVICE:
                    return ServiceAvatarSVG;
                case ScheduleType.CHECKUP:
                    return CheckupAvatarSVG;
                case ScheduleType.CHEMOTHERAPY:
                case ScheduleType.SURGERY:
                    return PhysicianAvatarSVG;
                default:
                    return ConsultationAvatarSVG;
            }
        };
    }
    static { AppointmentDashboardCard_1 = this; }
    static { this.propTypes = {
        allowCancelCheckup: string,
        allowConfirmCheckup: string,
        className: string,
        completedTasks: number,
        onAppointmentCancel: func,
        onAppointmentConfirm: func,
        onAppointmentReschedule: func,
        onAppointmentRescheduleMore: func,
        onClick: eventListener,
        onEnterTeleconsultation: func,
        patientId: number,
        rescheduleCheckup: string,
        rescheduleConsultation: string,
        rescheduleExam: string,
        rescheduleService: string,
        scheduleType: string,
        scheduleTypeOrigin: string,
        sequenceSchedule: number,
        statusWaitingList: string,
        totalTasks: number,
        uuid: string,
        width: number
    }; }
    static { this.defaultProps = {
        width: 3,
    }; }
    handleMenuCardActionClick() {
        this.abortOnClickCard = true;
    }
    getStatusSvg() {
        const { ieStatus } = this.props;
        switch (ieStatus) {
            case SCHEDULE_STATUS.APPROVED:
            case SCHEDULE_STATUS.CONFIRMED:
            case SCHEDULE_STATUS.DONE:
                return React.createElement(ConfirmedSVG, { width: 24, height: 24 });
            case SCHEDULE_OTHER_STATUS.EXECUTION:
            case SCHEDULE_STATUS.AWAITING_APPROVAL:
                return React.createElement(InExecutionSVG, { width: 24, height: 24 });
            case SCHEDULE_STATUS.MISSED:
                return React.createElement(LostSVG, { width: 24, height: 24 });
            case SCHEDULE_STATUS.NOT_APPROVED:
                return React.createElement(CanceledSVG, { width: 24, height: 24 });
            case SCHEDULE_OTHER_STATUS.REQUESTED:
                return React.createElement(RequestedSVG, { width: 24, height: 24 });
            case SCHEDULE_OTHER_STATUS.CANCELED:
            case SCHEDULE_STATUS.CANCELED:
                return React.createElement(CanceledSVG, { width: 24, height: 24 });
            default:
                return React.createElement(CheckSVG, { size: 18 });
        }
    }
    getStatusTextByIeStatus(ieStatus) {
        switch (ieStatus) {
            case SCHEDULE_STATUS.APPROVED: return MessageService.translate('patient.approved');
            case SCHEDULE_STATUS.AWAITING_APPROVAL: return MessageService.translate('patient.in-approval');
            case SCHEDULE_STATUS.CANCELED: return MessageService.translate('patient.canceled');
            case SCHEDULE_STATUS.CONFIRMED: return MessageService.translate('patient.confirmed');
            case SCHEDULE_STATUS.DONE: return MessageService.translate('patient.done');
            case SCHEDULE_STATUS.MISSED: return MessageService.translate('patient.missed');
            case SCHEDULE_STATUS.NOT_APPROVED: return MessageService.translate('patient.not.authorized');
            case SCHEDULE_OTHER_STATUS.REQUESTED: return MessageService.translate('patient.requested');
            case SCHEDULE_OTHER_STATUS.EXECUTION: return MessageService.translate('patient.execution');
            case SCHEDULE_OTHER_STATUS.CANCELED: return MessageService.translate('patient.canceled');
            default: return '';
        }
    }
    getHeaderCard(dateLabel) {
        const { ieStatus, ieScheduleType } = this.props;
        const cardAction = React.createElement("div", { onClick: () => this.handleMenuCardActionClick(), className: 'card-top-actions' },
            " ",
            AppointmentCardUtils.getCardAction(this.props),
            " ");
        if (ieScheduleType === ScheduleType.WAITING_LIST) {
            return (React.createElement("header", { className: "header-with-tag" },
                React.createElement(Tag, { value: MessageService.translate('patient.label.modal-scheduling-waiting-list'), formatters: {}, color: 'safety-orange' }),
                cardAction));
        }
        const icon = this.getStatusSvg();
        const status = this.getStatusTextByIeStatus(ieStatus);
        return (React.createElement("header", null,
            React.createElement("div", { className: "date" }, dateLabel),
            React.createElement("div", { className: "status" },
                React.createElement("span", null, status),
                icon,
                cardAction)));
    }
    getAppointmentDateTime(appointmentDate, appointmentTime) {
        const date = moment(appointmentDate);
        date.add(moment.duration(appointmentTime).asMinutes(), 'minutes');
        return date;
    }
    renderHeaderCard() {
        const { dtAgendamento, hrAgendamento } = this.props;
        const date = this.getAppointmentDateTime(dtAgendamento, hrAgendamento);
        const today = moment.utc().startOf('day');
        const dif = today.diff(date, 'days');
        const dateLabel = dif !== 0 ? date.fromNow() : date.calendar().split(' ')[0];
        return (React.createElement(React.Fragment, null, this.getHeaderCard(dateLabel)));
    }
    renderDefaultCard() {
        const { dsTitulo, dsFotoBase64, dsSubTitulo, dtAgendamento, hrAgendamento, ieScheduleType, dsTypeSchedule } = this.props;
        const avatarImage = dsFotoBase64 ? dsFotoBase64 : this.getAvatar(ieScheduleType);
        const date = this.getAppointmentDateTime(dtAgendamento, hrAgendamento);
        const hrAgendamentoFormatted = hrAgendamento ? getPreferredTime(hrAgendamento) : '';
        const dateFormatted = date.format('ll');
        const descriptionAvatar = dsTitulo ?? '-';
        const titleAvatar = dsSubTitulo ?? dsTypeSchedule;
        return (React.createElement(React.Fragment, null,
            React.createElement(Avatar, { title: titleAvatar, description: descriptionAvatar, size: Size.SMALL, image: avatarImage, className: 'avatar' }),
            React.createElement("div", { className: "info" },
                React.createElement("div", { className: "when" },
                    React.createElement(CalendarGray75SVG, null),
                    React.createElement("span", null,
                        React.createElement("span", { className: 'hrAgendamento' }, `${hrAgendamentoFormatted}`),
                        ` - ${dateFormatted}`)),
                React.createElement("div", { className: "location" }, this.renderLocationDetail()))));
    }
    renderLocationDetail() {
        const { dsEnderecoEstab, ieTelemedicina } = this.props;
        if (ieTelemedicina === 'S') {
            return (React.createElement(React.Fragment, null,
                React.createElement(TeleconsultationSVG, null),
                React.createElement("span", null, MessageService.translate('patient.teleconsultation'))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(LocationGray75SVG, null),
            React.createElement("span", null, dsEnderecoEstab || ' - ')));
    }
    onClickTeleconsultationButton() {
        this.abortOnClickCard = true;
        const { onEnterTeleconsultation, nrSequencia, ieScheduleType } = this.props;
        if (onEnterTeleconsultation != null) {
            onEnterTeleconsultation(nrSequencia, ieScheduleType);
        }
    }
    renderTeleconsultationButton() {
        const { ieTelemedicina, ieStatus, dtAgendamento } = this.props;
        if (ieTelemedicina === 'S' && ((ieStatus === SCHEDULE_STATUS.APPROVED)
            || (ieStatus === SCHEDULE_STATUS.CONFIRMED) || (ieStatus === SCHEDULE_OTHER_STATUS.EXECUTION))) {
            const actualDate = moment().startOf('day');
            const dateDiffInDays = moment(dtAgendamento).diff(actualDate, 'days');
            if (dateDiffInDays === 0) {
                return (React.createElement(Button, { onClick: () => this.onClickTeleconsultationButton(), value: MessageService.translate('appointment-card.btn-enter'), size: Size.SMALL, icon: '/static/assets/icons/camera-available.svg', iconPlacement: Placement.LEFT, theme: ButtonTheme.PRIMARY }));
            }
            return (React.createElement(Tag, { value: MessageService.translate('patient.teleconsultation'), formatters: {} }));
        }
        return React.createElement(React.Fragment, null);
    }
    renderProgress() {
        const { completedTasks = 0, ieScheduleType, totalTasks } = this.props;
        const tasksCompletedExpression = ieScheduleType === ScheduleType.CHECKUP
            ? MessageService.translate(EXPRESSIONS.STEPS_CONCLUDED)
            : MessageService.translate(EXPRESSIONS.TASKS_CONCLUDED);
        return (totalTasks ?
            React.createElement("div", { className: 'info' },
                React.createElement(ProgressBar, { leftText: `${completedTasks}/${totalTasks} ${tasksCompletedExpression}`, currentPart: completedTasks, maxParts: totalTasks })) : React.createElement(React.Fragment, null));
    }
    renderFooter() {
        const { totalTasks, ieTelemedicina } = this.props;
        const ieTelemedicinaValue = 'S';
        if (totalTasks !== 0 || ieTelemedicina === ieTelemedicinaValue) {
            return (React.createElement("div", { className: 'card-footer' },
                React.createElement("div", { className: 'footer-left' }, this.renderProgress()),
                React.createElement("div", { className: 'footer-right' }, this.renderTeleconsultationButton())));
        }
        return React.createElement(React.Fragment, null);
    }
    render() {
        const cardClass = 'appointment-dashboard-card';
        const { className, uuid: elementUuid, width = AppointmentDashboardCard_1.defaultProps.width } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(Card, { className: `${cardClass} ${className}`, onClick: this.handleClick, selectionType: SelectionType.SINGLE, uuid: elementUuid, transparent: false, width: width },
                React.createElement("div", { className: 'card-content' },
                    this.renderHeaderCard(),
                    React.createElement("div", { className: `${cardClass}__content` }, this.renderDefaultCard()),
                    this.renderFooter()))));
    }
};
AppointmentDashboardCard = AppointmentDashboardCard_1 = __decorate([
    AwesomeComponent({ api: AppointmentDashboardCardAPI, type: ComponentType.DATA_DISPLAY })
], AppointmentDashboardCard);
export default AppointmentDashboardCard;
//# sourceMappingURL=appointment-dashboard-card.js.map